<template>
  <div>
    <v-form ref       = "form"
            v-model   = "valid"
            :disabled = "loading"
    >
      <v-card class="add-location-card">
        <v-card-title>New location</v-card-title>
        <v-select
          :items     = "AllAliasTypes"
          item-text  = "1"
          item-value = "0"
          v-model    = "newLocation.type"
          label      = "Type of location"
          :rules     = "[rules.required]"
        ></v-select>
        <v-card-text>
          <v-text-field
            autofocus
            v-model = "newLocation.name"
            label   = "Name"
            :rules  = "[rules.required]"
          ></v-text-field>
          <v-text-field
            :key    = "newLocation.type"
            v-model = "newLocation.path"
            label   = "Path"
            :rules  = "[
              rules.pathRules,
              rules.startsWithHttp,
              rules.networkCorrect,
            ]"
          ></v-text-field>
          <div v-if="newLocation.type === AliasType.s3Bucket || newLocation.type === AliasType.genericS3 || newLocation.type === AliasType.googleCloudBucket || newLocation.type === AliasType.azureContainer"> 
            <v-select
              :items="delimiters"
              v-model="newLocation.delimiter"
              label="Delimiter"
            ></v-select>
          </div>

          <v-select
            :items  = "trueFalse"
            v-model = "newLocation.hidden"
            label   = "Hidden"
          ></v-select>
          <div v-if = "newLocation.type === AliasType.network">
            <v-text-field
              v-model = "newLocation.username"
              label   = "Username"
            ></v-text-field>
            <v-text-field
              v-model       = "newLocation.password"
              label         = "Password"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if = "newLocation.type === AliasType.s3Bucket">
            <v-text-field
              v-model = "newLocation.bucket"
              label   = "Bucket"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.region"
              label   = "Region"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.accessKey"
              label   = "Access Key"
            ></v-text-field>
            <v-text-field
              v-model       = "newLocation.secretAccessKey"
              label         = "Secret Access Key"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if = "newLocation.type === AliasType.genericS3">
            <v-text-field
              v-model = "newLocation.bucket"
              label   = "Bucket"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.serviceUrl"
              label   = "Service URL"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.accessKey"
              label   = "Access Key"
            ></v-text-field>
            <v-text-field
              v-model       = "newLocation.secretAccessKey"
              label         = "Secret Access Key"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if = "newLocation.type === AliasType.googleCloudBucket">
            <v-text-field
              v-model = "newLocation.bucket"
              label   = "Bucket"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.connectionString"
              label   = "JSON path"
              :rules  = "[rules.required]"
            ></v-text-field>
          </div>
          <div v-if = "newLocation.type === AliasType.azureContainer">
            <v-text-field
              v-model = "newLocation.container"
              label   = "Container"
              :rules  = "[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model = "newLocation.connectionString"
              label   = "Connection String"
              :rules  = "[rules.required]"
            ></v-text-field>
          </div>
          <div>
            <v-text-field
              v-model = "newLocation.cacheExpiration"
              label   = "Cache Expiration (s)"
              :rules  = "[rules.required]"
            ></v-text-field>
          </div>
          <div>
            <v-checkbox
              v-model   = "newLocation.backgroundCaching"
              label     = "Background Caching"
              ></v-checkbox>
          </div>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            text
            :disabled = "!valid || loading"
            @click    = "testConnection(newLocation)"
            v-if      = "!loading"
          >
            Test connection
          </v-btn>
          <v-btn text
                 @click = "cancelTest"
                 v-if   = "loading"
          >
            <v-icon left>mdi-loading mdi-spin</v-icon>
            Cancel test
          </v-btn>
          <div class = "row row--end">
            <v-btn text
                   @click    = "cancel"
                   :disabled = "loading"
            >Cancel
            </v-btn>
            <v-btn
              text
              color     = "primary"
              @click    = "add"
              :disabled = "!valid || loading"
            >Add location
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import {AliasType, AllAliasTypes, HttpTypes} from "../../services/locations.services";
import {HubConnection} from "@microsoft/signalr";
import {LocationTester} from "../../services/LocationTester";

export default {
  name:  "AddLocationsForm",
  props: {
    connection:  HubConnection,
    showSuccess: Function,
    showFailure: Function,
  },
  data() {
    return {
      valid:       false,
      trueFalse:   [true, false],
      delimiters:  ["/", "\\"],
      newLocation: {
        type:      AliasType.physical,
        name:      "",
        path:      "",
        delimiter: "/",
        hidden:    false,
        cacheExpiration:   2,
        backgroundCaching: false
      },
      loading:        false,
      locationTester: null,
      showPassword:   false,

      AliasType,
      AllAliasTypes,
      HttpTypes,

      rules: {
        required:       (value) => !!value || "Required",
        startsWithHttp: (value) => {
          if (this.HttpTypes.has(this.newLocation.type)) {
            return (
              value.startsWith("http://") ||
                value.startsWith("https://") ||
                "Value needs to start with 'http://' or 'https://'"
            );
          } else {
            return true;
          }
        },
        networkCorrect: (value) => {
          if (this.newLocation.type === AliasType.network) {
            return (
              value.startsWith("\\\\") || "Network needs to start with '\\\\'"
            );
          } else {
            return true;
          }
        },
        pathRules: (path) => {
          if (
            this.newLocation.type === AliasType.s3Bucket ||
              this.newLocation.type === AliasType.genericS3 ||
              this.newLocation.type === AliasType.googleCloudBucket ||
              this.newLocation.type === AliasType.azureContainer
          ) {
            return true;
          } else {
            return this.rules.required(path);
          }
        },
      },
    };
  },
  mounted() {
    this.locationTester = new LocationTester(this.connection);
  },
  methods: {
    add() {
      this.connection
        .invoke("AddAlias", this.newLocation)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("new-locations", response.entity);
            this.$emit("ok");
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    cancelTest() {
      this.locationTester.cancelTest();
    },
    async testConnection(location) {
      this.loading = true;
      this.locationTester.testAliasConnection(location).then(
        (response) => {
          if (response.resultKind === "Success") {
            this.showSuccess("Success");
          } else {
            this.showFailure(response.reason);
          }
          this.loading = false;
        },
        (error) => {
          this.showFailure(error);
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style>
.add-location-card{
  min-width: 450px;
  padding: 20px;
}
</style>
